import { useLocation } from 'react-router-dom';
import { useRoutes } from '../../Routes';

/**
 * Gets the route key for the current window location, or undefined if no routes match
 */
export const useCurrentRoute = (): string | undefined => {
  if (window.location.search.startsWith('?session_state')) {
    window.history.replaceState({}, '', window.location.origin);
  }

  const location = useLocation();
  const { ROUTES } = useRoutes();
  const currentRoute = ROUTES.find((r) => r.url === location.pathname)?.route as string | undefined;
  return currentRoute;
};
